import { render } from "./MediaDetail.vue?vue&type=template&id=79bd785d&ts=true"
import script from "./MediaDetail.vue?vue&type=script&lang=ts"
export * from "./MediaDetail.vue?vue&type=script&lang=ts"

import "./MediaDetail.vue?vue&type=style&index=0&id=79bd785d&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__